import MkuSelect from './src/select';

MkuSelect.install = function (Vue) {
  Vue.component(MkuSelect.name, MkuSelect);
};

export default MkuSelect;
